import { BRAND_UPPER } from "@/lib/site";

const Tile = ({ label, value, accent }) => (
  <div className="rounded-xl p-4" style={accent ? { background: "rgba(0,191,255,.06)", border: "1px solid rgba(0,191,255,.2)" } : { background: "rgba(255,255,255,.03)", border: "1px solid rgba(255,255,255,.06)" }}>
    <div className={`text-[10px] tracking-[0.2em] uppercase ${accent ? "text-[#7DDCFF]" : "text-slate-500"}`}>{label}</div>
    <div className={`font-display text-lg font-semibold ${accent ? "text-[#7DDCFF]" : ""}`}>{value}</div>
  </div>
);

export const WalletMock = () => (
  <div className="relative">
    <div className="absolute -inset-6 rounded-[36px] blur-3xl opacity-40" style={{ background: "radial-gradient(circle at 60% 40%, #00BFFF, transparent 60%)" }} aria-hidden="true" />
    <div className="relative wallet-card rounded-3xl p-6 sm:p-7 overflow-hidden" data-testid="wallet-mock" aria-hidden="true">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-2 text-xs text-[#7DDCFF] tracking-[0.2em] uppercase">
          <span className="w-1.5 h-1.5 rounded-full bg-[#00BFFF] pulse-ring inline-block" /> {BRAND_UPPER}
        </div>
        <div className="text-xs text-slate-400">Hi, Ral</div>
      </div>
      <div className="mb-1 text-xs text-slate-500 tracking-wider uppercase">Wallet Balance</div>
      <div className="font-display text-4xl sm:text-5xl font-bold">₹4,700<span className="text-slate-500">.06</span></div>
      <div className="grid grid-cols-2 gap-3 mt-6">
        <Tile label="Today" value="₹0.00" />
        <Tile label="Total Earned" value="₹2,149.06" accent />
      </div>
      <div className="grid grid-cols-3 gap-2 sm:gap-3 mt-3 text-center">
        {[["Deposits", "₹13,151"], ["Withdrawn", "₹10,700"], ["Team", "1"]].map(([l, v]) => (
          <div key={l} className="rounded-xl p-3 min-w-0" style={{ background: "rgba(255,255,255,.02)" }}>
            <div className="text-[10px] tracking-wider text-slate-500 uppercase truncate">{l}</div>
            <div className="text-sm font-semibold">{v}</div>
          </div>
        ))}
      </div>
    </div>
  </div>
);
